// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__39HbF","paramInput":"JobSimulator_paramInput__1i3pY","input":"JobSimulator_input__36SJe"};